import { render, staticRenderFns } from "./purseDetail.vue?vue&type=template&id=7fc35c4e&scoped=true"
import script from "./purseDetail.vue?vue&type=script&lang=js"
export * from "./purseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc35c4e",
  null
  
)

export default component.exports